import React from "react";

function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="10"
      viewBox="0 0 9 10"
      fill="none"
    >
      <path
        d="M9 5.64286H5.14286V9.5H3.85714V5.64286H0V4.35714H3.85714V0.5H5.14286V4.35714H9V5.64286Z"
        fill="white"
      />
    </svg>
  );
}

export default PlusIcon;
